







import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class BuyGetOne extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {
      return {
        quantity: 0,
        memberScope: "All",
        cumulativeWithOtherDiscount: false
      };
    }
  })
  value!: any;
}
